export default {
  supTitle: {
    en: 'Explore our list of',
  },
  title: {
    en: 'Frequently asked questions',
  },
}
